var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPerformance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 4C12.9543 4 4 12.9543 4 24C4 35.0457 12.9543 44 24 44C35.0457 44 44 35.0457 44 24C44 12.9543 35.0457 4 24 4ZM8.12379 22C9.10801 14.1074 15.8408 8 24 8C32.1592 8 38.892 14.1074 39.8762 22H34.1085L29.696 14.9401C29.3126 14.3266 28.6277 13.968 27.9051 14.0023C27.1824 14.0367 26.5347 14.4586 26.2111 15.1056L19.806 27.9159L16.696 22.94C16.3305 22.3552 15.6896 22 15 22H8.12379ZM8.12378 26C9.10796 33.8926 15.8407 40 24 40C32.1592 40 38.892 33.8926 39.8762 26H33C32.3104 26 31.6695 25.6447 31.304 25.06L28.194 20.0841L21.7889 32.8944C21.4653 33.5415 20.8176 33.9634 20.0949 33.9977C19.3723 34.0321 18.6874 33.6735 18.304 33.06L13.8915 26H8.12378Z",
    fill: "#d9ff02"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerformance);
export default __webpack_public_path__ + "static/media/performance.9cbdef9f.svg";
export { ForwardRef as ReactComponent };